// Comprehensive small-business-relevant industry list, ordered alphabetically.
// Used across the onboarding form + accountant's Add Client + Super Admin Add Client.
export const INDUSTRIES = [
  "Accounting & Financial Services",
  "Agriculture & Farming",
  "Architecture & Engineering",
  "Arts & Entertainment",
  "Automotive",
  "Beauty & Personal Care",
  "Cannabis",
  "Childcare & Family Services",
  "Cleaning & Facility Services",
  "Construction & Contracting",
  "Consulting",
  "Consumer Goods",
  "E-commerce",
  "Education & Training",
  "Energy & Utilities",
  "Environmental Services",
  "Event Planning",
  "Fashion & Apparel",
  "Fitness & Wellness",
  "Food & Beverage",
  "Government",
  "Healthcare & Medical",
  "Home Services",
  "Hospitality (Hotels & Restaurants)",
  "Human Resources & Staffing",
  "Insurance",
  "Legal Services",
  "Logistics & Transportation",
  "Manufacturing",
  "Marketing & Advertising",
  "Media & Publishing",
  "Mining & Materials",
  "Non-profit",
  "Pet Services",
  "Photography & Videography",
  "Printing & Publishing",
  "Professional Services",
  "Real Estate",
  "Religious Organizations",
  "Retail",
  "Security Services",
  "Software / Technology / SaaS",
  "Sports & Recreation",
  "Telecommunications",
  "Trades (Plumbing / Electrical / HVAC)",
  "Travel & Tourism",
  "Veterinary Services",
  "Wholesale & Distribution",
  "Other",
];
